export default {
      id: "Icon--commentAdd-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--commentAdd",
      toString: function () {
        return this.url;
      }
    }